<template>
  <div @click="upload">
    <slot></slot>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    text: { type: String, default: 'upload-text' },
    authEndpoint: { type: Function, default: null },
    createEndpoint: { type: Function, default: null },
    modelId: { type: String, default: null },
    source: { type: String, default: null },
    version: { type: Number, default: 2 },
    dataVersionId: { type: String, default: null },
    dockerImageId: { type: String, default: null },
    successText: { type: String, default: '' },
    sizeLimit: { type: Number, default: null },
    onSuccess: { type: Function, default: null },
    onFailure: { type: Function, default: null },
    onUploadStart: { type: Function, default: null },
    onUploadEnd: { type: Function, default: null },
    isDiagnostics: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  methods: {
    ...mapActions(['showSnackBar', 'fetchAccountInfo']),
    async upload() {
      if (this.disabled) {
        return
      }
      const input = document.createElement('input')
      input.type = 'file'
      input.style.cssText = 'visibility:hidden'
      input.addEventListener('change', this.onChange)
      document.body.appendChild(input)
      input.click()
      input.remove()
    },
    async onChange(e) {
      const file = e.target.files[0]
      if (!file) {
        return
      }
      if (this.sizeLimit && file.size > this.sizeLimit) {
        this.showSnackBar({ msg: 'File must be below 200kb', time: 0 })
        return
      }
      try {
        this.onUploadStart && this.onUploadStart()

        // ask the backend for a url to upload to
        this.showSnackBar({ msg: 'Authenticating...', time: 0 })

        // save model id to local variable in case it changes during upload
        const modelId = this.modelId
        const { url, filename } = await this.authEndpoint({
          filename: file.name,
          modelId: modelId,
        })

        // upload to that URL
        this.showSnackBar({ msg: 'Uploading...', time: 0 })
        await put(url, file)

        // create submission in backend
        if (this.createEndpoint) {
          this.showSnackBar({ msg: 'Validating...', time: 0 })
          await this.createEndpoint({
            filename,
            modelId: modelId,
            version: this.version,
            dataVersionId: this.dataVersionId,
            dockerImageId: this.dockerImageId,
            source: this.source,
          })
        }

        this.showSnackBar({ msg: this.successText })

        this.$emit('upload')

        // fetch user info and poll for 30 seconds if uploading submission
        if (!this.isDiagnostics) {
          await this.fetchAccountInfo()
          setTimeout(this.fetchAccountInfo, 10 * 1000)
          setTimeout(this.fetchAccountInfo, 20 * 1000)
          setTimeout(this.fetchAccountInfo, 30 * 1000)
        }

        if (this.onSuccess) this.onSuccess()
      } catch (e) {
        this.showSnackBar({ msg: e.message, time: 0 })
        if (this.onFailure) this.onFailure()
      } finally {
        this.onUploadEnd && this.onUploadEnd()
      }
    },
  },
}

// Helper function to wrap XHR in promise
function put(url, file) {
  // Return a new promise.
  return new Promise(function(resolve, reject) {
    // Do the usual XHR stuff
    var req = new XMLHttpRequest()
    req.open('put', url, true)

    req.onload = function() {
      // This is called even on 404 etc
      // so check the status
      if (req.status == 200) {
        // Resolve the promise with the response text
        resolve(req.response)
      } else {
        // Otherwise reject with the status text
        // which will hopefully be a meaningful error
        reject(Error(req.statusText))
      }
    }

    // Handle network errors
    req.onerror = function() {
      reject(Error('Network Error'))
    }

    // Make the request
    req.send(file)
  })
}
</script>
